import { Box, Typography } from '@mui/material';
import { Avatar } from 'requiro-ui-theme';

const TitleWorkspace = ({ t, user, smMediaQuery }) => {
  let name = '-';
  let surname = '-';

  if (user.name) name = user.name;
  if (user.surname) surname = user.surname;
  return (
    <>
      <Avatar
        sx={{
          border: '1px solid #bbbcbe !important',
          fontSize: smMediaQuery ? '0.8em' : '1.2em',
        }}
        size={smMediaQuery ? 50 : 70}
        alt={name + ' ' + surname}
      >
        {name + ' ' + surname}
      </Avatar>
      <div style={{ flexGrow: 1 }}>
        <Typography
          variant="body1"
          component="div"
          sx={{
            color: '#1A416B',
          }}
        >
          {!smMediaQuery && `${t('signedWorkSpace', "You're signed in as")} `}
          <Box component="span" fontWeight="bold">
            {user.username}
          </Box>
        </Typography>
        <Typography
          variant="h4"
          component="div"
          sx={{
            ...(smMediaQuery && { fontSize: '1rem' }),
            ...(!smMediaQuery && { letterSpacing: '2px' }),
            color: '#1A416B',
          }}
        >
          {t('titleWorkSpace', 'You can access the following workspaces')}
        </Typography>
      </div>
    </>
  );
};

export default TitleWorkspace;
